import { render } from "./WhyVitralCSS.vue?vue&type=template&id=4554473f&scoped=true"
import script from "./WhyVitralCSS.vue?vue&type=script&lang=js"
export * from "./WhyVitralCSS.vue?vue&type=script&lang=js"

import "./WhyVitralCSS.vue?vue&type=style&index=0&id=4554473f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4554473f"]])

export default __exports__